import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { VariableBenefitAccountDetails } from '../../../../../../models/transactions/variable-benefit-account-details';
import { ButtonTypeEnum } from '../../../../../../ui/buttons/button/button-type.enum';
import { TrackByUtils } from '../../../../../../utils/track-by-utils';
import { GoverningJurisdictionTypeId } from '../../../../../../models/enum/shared/governing-jurisdiction-type-id';

@Component({
  selector: 'app-vb-payment-change-upcoming-lump-sum-payments',
  templateUrl: './vb-payment-change-upcoming-lump-sum-payments.component.html',
  styleUrls: ['./vb-payment-change-upcoming-lump-sum-payments.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentChangeUpcomingLumpSumPaymentsComponent implements OnChanges {
  @Input({ required: true }) accountDetails!: VariableBenefitAccountDetails[];
  @Output() viewPastLumpSumPayments = new EventEmitter<void>();

  public hasPreviousLumpSumPayments: boolean = false;
  public paymentDate: string = '';
  public rows: { governingJurisdictionId: GoverningJurisdictionTypeId | null; amount: number }[] = [];
  public total: number = 0;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.accountDetails) {
      this.hasPreviousLumpSumPayments = this.accountDetails.some(
        detail => (detail.historicalLumpSumPayments ?? []).length > 0
      );

      const lumpSumPayments = this.accountDetails.filter(detail => !!detail.scheduledLumpSumPaymentInstruction);

      this.rows = lumpSumPayments.map(detail => {
        return {
          governingJurisdictionId: detail.governingJurisdictionId,
          amount: detail.scheduledLumpSumPaymentInstruction?.paymentAmount ?? 0
        };
      });

      this.paymentDate = lumpSumPayments?.first()?.scheduledLumpSumPaymentInstruction?.desiredPaymentDate ?? '';
      this.total = this.rows.reduce((sum, row) => sum + row.amount, 0);
    }
  }

  protected readonly ButtonTypeEnum = ButtonTypeEnum;
  protected readonly trackByIndex = TrackByUtils.trackByIndex;
}
